import { CapacitorIcon,
    TypescriptIcon,
    SqlIcon,
    NodeIcon,
    MongoIcon,
    IonicIcon,
    GitIcon,
    FirebaseIcon,
    BootstrapIcon,
    AndroidIcon,
    LaravelIcon,
    ReactIcon, 
    HtmlIcon,
    PhpIcon,
  CssIcon,
  JavascriptIcon,
  } from '../assets/svg/index'

  const skillsData = [
  {
    icon: <TypescriptIcon />,
    Name: 'TypeScript',
    Description: 'A strongly typed programming language that builds on JavaScript.'
  },
  {
    icon: <JavascriptIcon />,
    Name: 'JavaScript',
    Description: 'A versatile scripting language mainly used for web development.'
  },
  {
    icon: <HtmlIcon />,
    Name: 'HTML',
    Description: 'The standard markup language for creating web pages.'
  },
  {
    icon: <CssIcon />,
    Name: 'CSS',
    Description: 'A style sheet language used for describing the presentation of a document written in HTML.'
  },
  {
    icon: <ReactIcon />,
    Name: 'React',
    Description: 'A JavaScript library for building user interfaces.'
  },
  {
    icon: <NodeIcon />,
    Name: 'Node Js',
    Description: 'A JavaScript runtime built on Chrome\'s V8 JavaScript engine.'
  },
  {
    icon: <PhpIcon />,
    Name: 'PHP',
    Description: 'A popular general-purpose scripting language especially suited to web development.'
  },
  {
    icon: <LaravelIcon />,
    Name: 'Laravel',
    Description: 'A PHP framework for web artisans, providing elegant syntax and features.'
  },
  {
    icon: <AndroidIcon />,
    Name: 'Android',
    Description: 'An open-source operating system for mobile devices, primarily developed by Google.'
  },
  {
    icon: <BootstrapIcon />,
    Name: 'Bootstrap',
    Description: 'A free and open-source CSS framework for responsive, mobile-first front-end web development.'
  },
  {
    icon: <IonicIcon />,
    Name: 'Ionic',
    Description: 'A complete open-source SDK for hybrid mobile app development.'
  },
  {
    icon: <CapacitorIcon />,
    Name: 'Capacitor',
    Description: 'A cross-platform app runtime that makes it easy to build web apps that run natively on iOS, Android, and the web.'
  },
  {
    icon: <SqlIcon />,
    Name: 'SQL',
    Description: 'A standard language for storing, manipulating, and retrieving data in databases.'
  },
  {
    icon: <FirebaseIcon />,
    Name: 'Firebase',
    Description: 'A platform developed by Google for creating mobile and web applications.'
  },
  {
    icon: <MongoIcon />,
    Name: 'Mongo DB',
    Description: 'A source-available cross-platform document-oriented database program.'
  },
  {
    icon: <GitIcon />,
    Name: 'Git',
    Description: 'A free and open-source distributed version control system.'
  },
];

  
  export default skillsData;